import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cardContentRoot: {
        padding: '5px',
        '&:last-child': {
            paddingBottom: '5px',
        },
        '& > p': {
            fontWeight: 400,
        }
    }
}))